/** @format */

import React from "react";
import LandingPage from "../../components/LandingPage";

export default function Konnect654() {
  return (
    <LandingPage
      type="without"
      iosUrl="https://iosStorage.com"
      androidUrl="https://androidStorage.com"
    />
  );
}
